import React, { useState, useRef, useEffect } from "react";
import { ChevronLeft } from "lucide-react";

const Dropdown = ({
  options = [],
  value,
  onChange,
  placeholder = "Select an option",
  className = "",
  width = "w-48",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    onChange(option.value);
    setIsOpen(false);
  };

  const selectedOption = options.find((opt) => opt.value === value);
  const displayText = selectedOption ? selectedOption.label : placeholder;

  return (
    <div
      ref={dropdownRef}
      className={`${width} h-12 relative font-['Manrope'] ${className}`}
    >
      {/* Dropdown Button */}
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full h-full px-4 py-3 bg-white rounded-lg outline outline-1 outline-blue-100 text-gray-500 text-base font-medium cursor-pointer hover:bg-blue-50 transition-colors flex items-center justify-between"
      >
        <span className={selectedOption ? "text-gray-900" : "text-gray-500"}>
          {displayText}
        </span>
        <ChevronLeft
          size={14}
          className={`transition-transform duration-200 ${
            isOpen ? "rotate-90" : "-rotate-90"
          }`}
        />
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute top-full left-0 right-0 mt-1 bg-white rounded-lg outline outline-1 outline-blue-100 shadow-lg z-50 max-h-60 overflow-y-auto">
          {options.map((option, idx) => (
            <button
              key={idx}
              type="button"
              onClick={() => handleSelect(option)}
              className={`w-full px-4 py-3 text-left text-base font-medium transition-colors ${
                option.value === value
                  ? "bg-blue-100 text-gray-900"
                  : "text-gray-500 hover:bg-blue-50"
              } ${idx === 0 ? "rounded-t-lg" : ""} ${
                idx === options.length - 1 ? "rounded-b-lg" : ""
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
